/**
 * This file is used to get all external js files and add them into the theme
 */
require( 'bootstrap' );
require( '../bin/libs/jquery-ui-custom/jquery-ui.min' );
require( '@fortawesome/fontawesome-free/js/all.min' );